import { courseLinks } from '../../data/coursesData';
import config from '../../utility/config';
import { isDesktop, isMobileOrTablet } from '../../utility/domHelpers';

const cdnBasePath = config.imagesBasePath;
const imagesBaseURL = cdnBasePath + '/na-website/NewHome';

const mobileSrcMap = [
  {
    src: `${imagesBaseURL}/video/hero_trailer_mobile_new.mp4`,
    type: 'video/mp4',
  },
];

const desktopSrcMap = [
  {
    src: `${imagesBaseURL}/video/hero_trailer_desktop_new.mp4`,
    type: 'video/mp4',
  },
];

export const mobileVideoProps = {
  loop: true,
  autoPlay: true,
  playsInline: true,
  muted: true,
  srcMap: mobileSrcMap,
  stopOnScroll: false,
};

export const desktopVideoProps = {
  ...mobileVideoProps,
  srcMap: desktopSrcMap,
};

export const bannerStaticProps = {
  title: [
    { text: 'Join the', isHighlighted: true },
    {
      text: 'Creator Revolution',
      isNewLine: true,
    },
  ],
  subtitle: 'Those Who Can Do, Also Teach.',
  actionBtnLabel: 'Learn From a Creator',
  videoProps: {
    loop: true,
    autoPlay: true,
    playsInline: true,
    muted: true,
    checkIsInView: false,
    cover: null,
    srcMap: [
      {
        src: `${cdnBasePath}/homePageVideo.mp4`,
        meta: {
          width: 324,
          height: 185,
        },
        type: 'video/mp4',
      },
    ],
  },
};

export const descriptionCardsStaticProps = {
  title: [
    {
      text: 'A new way of learning',
    },
  ],
  cards: [
    {
      title: [
        { text: 'In 1 hour,' },
        { text: ' learn a new skill.', isNewLine: true },
      ],
      imgSrc: {
        alt: '1h Class',
        mobileImgData: {
          webpSrc: `${imagesBaseURL}/webp/1hClass328x280.webp`,
          src: `${imagesBaseURL}/png/1hClass328x280.png`,
          meta: {
            width: 328,
            height: 280,
          },
        },
        desktopImgData: {
          webpSrc: `${imagesBaseURL}/webp/1hClass798x676.webp`,
          src: `${imagesBaseURL}/png/1hClass798x676.png`,
          meta: {
            width: 798,
            height: 676,
          },
        },
      },
      description: [
        {
          text: `Our classes are highly engaging, super energetic, and straight to the point.`,
        },
        {
          text: `Each class is translated to 10 languages, so you can learn however you want.`,
        },
      ],
      cta: { label: 'play class sample', icon: 'play' },
    },
    {
      title: [
        { text: 'Exclusive whatsapp community.' },
        { text: 'Active peer learning - 24/7', isNewLine: true },
      ],
      imgSrc: {
        alt: 'Exclusive WhatsApp',
        mobileImgData: {
          webpSrc: `${imagesBaseURL}/webp/exclusiveWApp328x409.webp`,
          src: `${imagesBaseURL}/png/exclusiveWApp328x409.png`,
          meta: {
            width: 328,
            height: 409,
          },
        },
        desktopImgData: {
          webpSrc: `${imagesBaseURL}/webp/exclusiveWapp727x677.webp`,
          src: `${imagesBaseURL}/png/exclusiveWapp727x677.png`,
          meta: {
            width: 727,
            height: 677,
          },
        },
      },
      description: [
        {
          text: `Humans learn better in groups. Our unique model of having a dedicated whatsapp group with co-learners and trainers will amplify your learning.`,
        },
      ],
    },
    {
      title: [
        { text: 'Get personalized feedback' },
        { text: 'on your assignments.', isNewLine: true },
      ],
      imgSrc: {
        alt: 'Personalized Feedback',
        mobileImgData: {
          webpSrc: `${imagesBaseURL}/webp/personalizedFeedback328x235.webp`,
          src: `${imagesBaseURL}/png/personalizedFeedback328x235.png`,
          meta: {
            width: 328,
            height: 235,
          },
        },
        desktopImgData: {
          webpSrc: `${imagesBaseURL}/webp/personalizedFeedback734x512.webp`,
          src: `${imagesBaseURL}/png/personalizedFeedback734x512.png`,
          meta: {
            width: 734,
            height: 512,
          },
        },
      },
      description: [
        {
          text: `Every person has their own learning style. With our committed trainers and small batch sizes, you'll get the personal attention needed to boast your growth.`,
        },
      ],
    },
    {
      title: [
        { text: 'Meet & greet with the' },
        { text: 'creators - LIVE', isNewLine: true },
      ],
      imgSrc: {
        alt: 'Creators Live',
        mobileImgData: {
          webpSrc: `${imagesBaseURL}/webp/creatorsLive328x270.webp`,
          src: `${imagesBaseURL}/png/creatorsLive328x270.png`,
          meta: {
            width: 328,
            height: 270,
          },
        },
        desktopImgData: {
          webpSrc: `${imagesBaseURL}/webp/creatorsLive721x576.webp`,
          src: `${imagesBaseURL}/png/creatorsLive721x576.png`,
          meta: {
            width: 721,
            height: 576,
          },
        },
      },
      description: [
        {
          text: `Get up-close and personal with your favourite creators in a LIVE session every month. Feed your curiosity with answers that elevate your skills and take you to the next level.`,
        },
      ],
    },
  ],
  cardsB: [
    {
      title: [
        { text: 'Learn a' },
        { text: ' new skill from your', isNewLine: true },
        { text: ' favorite creators.', isNewLine: true },
      ],
      imgSrc: {
        alt: '1h Class',
        mobileImgData: {
          webpSrc: `${imagesBaseURL}/webp/mobile2x.webp`,
          src: `${imagesBaseURL}/png/mobile2x.png`,
          meta: {
            width: 328,
            height: 280,
          },
        },
        desktopImgData: {
          webpSrc: `${imagesBaseURL}/webp/desktop2x.webp`,
          src: `${imagesBaseURL}/png/desktop2x.png`,
          meta: {
            width: 798,
            height: 676,
          },
        },
      },
      description: [
        {
          text: `Our classes are highly engaging, super energetic, and straight to the point.`,
        },
        {
          text: `Each class is translated to 10 languages, so you can learn however you want.`,
        },
      ],
      cta: { label: 'play class sample', icon: 'play' },
    },
    {
      title: [
        { text: 'Exclusive whatsapp community.' },
        { text: 'Active peer learning - 24/7', isNewLine: true },
      ],
      imgSrc: {
        alt: 'Exclusive WhatsApp',
        mobileImgData: {
          webpSrc: `${imagesBaseURL}/webp/exclusiveWApp328x409.webp`,
          src: `${imagesBaseURL}/png/exclusiveWApp328x409.png`,
          meta: {
            width: 328,
            height: 409,
          },
        },
        desktopImgData: {
          webpSrc: `${imagesBaseURL}/webp/exclusiveWapp727x677.webp`,
          src: `${imagesBaseURL}/png/exclusiveWapp727x677.png`,
          meta: {
            width: 727,
            height: 677,
          },
        },
      },
      description: [
        {
          text: `Humans learn better in groups. Our unique model of having a dedicated whatsapp group with co-learners and trainers will amplify your learning.`,
        },
      ],
    },
    {
      title: [
        { text: 'Get personalized feedback' },
        { text: 'on your assignments.', isNewLine: true },
      ],
      imgSrc: {
        alt: 'Personalized Feedback',
        mobileImgData: {
          webpSrc: `${imagesBaseURL}/webp/personalizedFeedback328x235.webp`,
          src: `${imagesBaseURL}/png/personalizedFeedback328x235.png`,
          meta: {
            width: 328,
            height: 235,
          },
        },
        desktopImgData: {
          webpSrc: `${imagesBaseURL}/webp/personalizedFeedback734x512.webp`,
          src: `${imagesBaseURL}/png/personalizedFeedback734x512.png`,
          meta: {
            width: 734,
            height: 512,
          },
        },
      },
      description: [
        {
          text: `Every person has their own learning style. With our committed trainers and small batch sizes, you'll get the personal attention needed to boast your growth.`,
        },
      ],
    },
    {
      title: [
        { text: 'Meet & greet with the' },
        { text: 'creators - LIVE', isNewLine: true },
      ],
      imgSrc: {
        alt: 'Creators Live',
        mobileImgData: {
          webpSrc: `${imagesBaseURL}/webp/creatorsLive328x270.webp`,
          src: `${imagesBaseURL}/png/creatorsLive328x270.png`,
          meta: {
            width: 328,
            height: 270,
          },
        },
        desktopImgData: {
          webpSrc: `${imagesBaseURL}/webp/creatorsLive721x576.webp`,
          src: `${imagesBaseURL}/png/creatorsLive721x576.png`,
          meta: {
            width: 721,
            height: 576,
          },
        },
      },
      description: [
        {
          text: `Get up-close and personal with your favourite creators in a LIVE session every month. Feed your curiosity with answers that elevate your skills and take you to the next level.`,
        },
      ],
    },
  ],
};

export const courseCardsStaticProps = {
  subTitle: [{ text: 'HIGHLY ENGAGING CLASSES THAT EMPOWER' }],
  mainTitle: [{ text: `Learn from the world's best creators` }],
  creatorProps: [
    {
      isMetakovan: true,
      name: [
        { text: 'from' },
        { text: 'METAPURSE', isBolder: true, isNewLine: true },
      ],
      iconName: 'metakovanCreatorIcon',
      courseNameLabel: [
        { text: 'The Future ', forDarkScreen: true },
        { text: 'Of Crypto', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'NFT BUYER',
      statCount: '69',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/Meta.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/Meta.webp`,
        },
        alt: 'metakovan',
      },
      type: 'image',
      courseLink: courseLinks?.MKPR,
    },
    {
      name: [
        { text: 'from' },
        { text: 'Nuseir Yassin', isBolder: true, isNewLine: true },
      ],
      iconName: 'nasDailyLightIcon',
      courseNameLabel: [
        { text: 'Learn the', forDarkScreen: true },
        { text: 'Art of Storytelling', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '34',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/ND.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/ND.webp`,
        },
        alt: 'art of storytelling',
      },
      type: 'image',
      courseLink: '/course/storytelling',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Alyne Tamir', isBolder: true, isNewLine: true },
      ],
      iconName: 'alyneCreatorIcon',
      courseNameLabel: [
        { text: "Let's", forDarkScreen: true },
        { text: "Talk Money", isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '3',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/DAMoney/png/DAM_Course_card.png`,
          webpSrc: `${cdnBasePath}/na-website/DAMoney/webp/DAM_Course_card.webp`,
        },
        alt: 'dear alyne',
      },
      type: 'image',
      courseLink: '/dearalyne/money',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Team Nas Daily', isBolder: true, isNewLine: true },
      ],
      iconName: 'nasDailyLightIcon',
      courseNameLabel: [
        { text: 'Creator ', isHighlighted: true },
        { text: 'Mastercourse', forDarkScreen: true, isNewLine: true },
      ],
      statLabel: 'Alumni',
      statCount: '4',
      statUnit: 'K+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/creator_mastercourse_new.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/creator_mastercourse_new.webp`,
        },
        alt: 'nuseir-hero',
      },
      type: 'image',
      courseLink: '/course/creator',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Smile Squad', isBolder: true, isNewLine: true },
      ],
      iconName: 'markianCreatorIcon',
      courseNameLabel: [
        { text: 'Learn', forDarkScreen: true },
        { text: 'Comedy', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '13',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/SQ.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/SQ.webp`,
        },
        alt: 'nuseir-hero',
      },
      type: 'image',
      courseLink: '/smilesquad/comedy-skits',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Ming Wei', isBolder: true, isNewLine: true },
      ],
      iconName: 'mingCreatorIcon',
      courseNameLabel: [
        { text: 'Master', forDarkScreen: true },
        { text: 'TikTok', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '20',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/Ming.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/Ming.webp`,
        },
        alt: 'ming wei',
      },
      type: 'image',
      courseLink: '/ming-wei/unlocking-tiktok-with-ming',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Agon Hare', isBolder: true, isNewLine: true },
      ],
      iconName: 'projectNightfallCreatorIcon',
      courseNameLabel: [
        { text: 'Learn', forDarkScreen: true },
        { text: 'Infectious', isHighlighted: true, isNewLine: true },
        { text: 'Confidence', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '10',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/Agon.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/Agon.webp`,
        },
        alt: 'project nightfall',
      },
      type: 'image',
      courseLink: '/course/confidence',
    },
  ],
};

export const courseCardsStaticPropsV2 = {
  subTitle: [{ text: 'HIGHLY ENGAGING CLASSES THAT EMPOWER' }],
  creatorProps: [
    {
      isMetakovan: true,
      name: [
        { text: 'from' },
        { text: 'METAPURSE', isBolder: true, isNewLine: true },
      ],
      iconName: 'metakovanCreatorIcon',
      courseNameLabel: [
        { text: 'The Future ', forDarkScreen: true },
        { text: 'Of Crypto', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'NFT BUYER',
      statCount: '69',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/Meta.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/Meta.webp`,
        },
        alt: 'metakovan',
      },
      type: 'image',
      courseLink: courseLinks?.MKPR,
    },
    {
      name: [
        { text: 'from' },
        { text: 'Nuseir Yassin', isBolder: true, isNewLine: true },
      ],
      iconName: 'nasDailyLightIcon',
      courseNameLabel: [
        { text: 'Learn the', forDarkScreen: true },
        { text: 'Art of Storytelling', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '34',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/ND.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/ND.webp`,
        },
        alt: 'art of storytelling',
      },
      type: 'image',
      courseLink: '/course/storytelling',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Alyne Tamir', isBolder: true, isNewLine: true },
      ],
      iconName: 'alyneCreatorIcon',
      courseNameLabel: [
        { text: "Let's", forDarkScreen: true },
        { text: 'Talk Money', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '3',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/DAMoney/png/DAM_Course_card.png`,
          webpSrc: `${cdnBasePath}/na-website/DAMoney/webp/DAM_Course_card.webp`,
        },
        alt: 'dear alyne',
      },
      type: 'image',
      courseLink: '/dearalyne/money',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Team Nas Daily', isBolder: true, isNewLine: true },
      ],
      iconName: 'nasDailyLightIcon',
      courseNameLabel: [
        { text: 'Creator ', isHighlighted: true },
        { text: 'Mastercourse', forDarkScreen: true, isNewLine: true },
      ],
      statLabel: 'Alumni',
      statCount: '4',
      statUnit: 'K+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/creator_mastercourse_new.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/creator_mastercourse_new.webp`,
        },
        alt: 'nuseir-hero',
      },
      type: 'image',
      courseLink: '/course/creator',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Smile Squad', isBolder: true, isNewLine: true },
      ],
      iconName: 'markianCreatorIcon',
      courseNameLabel: [
        { text: 'Learn', forDarkScreen: true },
        { text: 'Comedy', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '13',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/SQ.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/SQ.webp`,
        },
        alt: 'nuseir-hero',
      },
      type: 'image',
      courseLink: '/smilesquad/comedy-skits',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Ming Wei', isBolder: true, isNewLine: true },
      ],
      iconName: 'mingCreatorIcon',
      courseNameLabel: [
        { text: 'Master', forDarkScreen: true },
        { text: 'TikTok', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '20',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/Ming.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/Ming.webp`,
        },
        alt: 'ming wei',
      },
      type: 'image',
      courseLink: '/ming-wei/unlocking-tiktok-with-ming',
    },
    {
      name: [
        { text: 'from' },
        { text: 'Agon Hare', isBolder: true, isNewLine: true },
      ],
      iconName: 'projectNightfallCreatorIcon',
      courseNameLabel: [
        { text: 'Learn', forDarkScreen: true },
        { text: 'Infectious', isHighlighted: true, isNewLine: true },
        { text: 'Confidence', isHighlighted: true, isNewLine: true },
      ],
      statLabel: 'Followers',
      statCount: '10',
      statUnit: 'M+',
      cover: {
        mobileImgData: {
          src: `${cdnBasePath}/na-website/NewHome/jpg/Agon.jpg`,
          webpSrc: `${cdnBasePath}/na-website/NewHome/webp/Agon.webp`,
        },
        alt: 'project nightfall',
      },
      type: 'image',
      courseLink: '/course/confidence',
    },
  ],
};

export const creatorMastercourseSectionStaticProps = {
  stats: [
    {
      prop: 'TYPE',
      value: 'LIVE',
      type: 'lessons',
    },
    {
      prop: 'DURATION',
      value: '1',
      type: 'month',
    },
  ],
  coverImg: {
    alt: 'creator cover',
    mobileImgData: {
      webpSrc:
        'https://d2oi1rqwb0pj00.cloudfront.net/na-website/CreatorCourseDark/webp/cover_img_mobile.webp',
      src:
        'https://d2oi1rqwb0pj00.cloudfront.net/na-website/CreatorCourseDark/png/cover_img_mobile.png',
      meta: {
        width: 828,
        height: 745,
      },
    },
    desktopImgData: {
      webpSrc:
        'https://d2oi1rqwb0pj00.cloudfront.net/na-website/CreatorCourseDark/png/peopleBg.png',
      src:
        'https://d2oi1rqwb0pj00.cloudfront.net/na-website/CreatorCourseDark/png/peopleBg.png',
      meta: {
        width: 828,
        height: 745,
      },
    },
  },
};

export const starImageData = {
  alt: 'Star Rating',
  mobileImgData: {
    src:
      'https://d2oi1rqwb0pj00.cloudfront.net/na-website/CreatorCourseDark/svg/stars.svg',
  },
};

export const businessSectionStaticProps = {
  title: 'For Businesses',
  description: [
    { text: 'Invest in your team,', isNewLine: true },
    { text: 'because they can be', isNewLine: true },
    { text: 'your best storytellers.', isHighlighted: true },
  ],
  btnText: 'LEARN MORE',
  heroImgData: {
    alt: 'Business',
    mobileImgData: {
      webpSrc: `${imagesBaseURL}/webp/businessMobile_328x198.webp`,
      src: `${imagesBaseURL}/png/businessMobile_328x198.png`,
      meta: {
        width: 328,
        height: 198,
      },
    },
    desktopImgData: {
      webpSrc: `${imagesBaseURL}/webp/businessDesktop_1360x820.webp`,
      src: `${imagesBaseURL}/png/businessDesktop_1360x820.png`,
      meta: {
        width: 1360,
        height: 820,
      },
    },
  },
  // TODO
  // partnersImageData: {
  //   alt: 'Partners',
  //   mobileImgData: {
  //     src: `${imagesBaseURL}/png/partners.png`,
  //   },
  // },
  // partnersBgData: [

  // ]
};

export const introBannerStaticPropsV1 = {
  title: [
    { text: 'World’s most engaging', isNewLine: true },
    { text: '1 hour classes.', isHighlighted: true },
  ],
  description: [
    { text: "Made by the world's most engaging creators", isBolder: true },
    {
      text: ' - packed with fun,',
    },
    {
      text: 'experience & diversity with a community of extraordinary creators',
      isNewLine: true,
    },
  ],
  btnText: 'I AM INTERESTED',
  heroImageData: {
    alt: 'NasAcademy',
    mobileImgData: {
      webpSrc: `${imagesBaseURL}/webp/bannerMobileV1_360x610.webp`,
      src: `${imagesBaseURL}/png/bannerMobileV1_360x610.png`,
      meta: {
        width: 360,
        height: 610,
      },
    },
    desktopImgData: {
      webpSrc: `${imagesBaseURL}/webp/bannerDesktopV1_705x823.webp`,
      src: `${imagesBaseURL}/png/bannerDesktopV1_705x823.png`,
      meta: {
        width: 705,
        height: 823,
      },
    },
  },
};

export const introBannerStaticPropsV2 = {
  title: [
    { text: 'Learn from a league of ', isNewLine: true },
    { text: 'extraordinary creators.', isHighlighted: true },
  ],
  description: [
    { text: 'Those who can do, also teach on Nas Academy.', isBolder: true },
    {
      text: ' Learn from tons of',
    },
    {
      text: 'creators directly in a new educational experience.',
      isNewLine: true,
    },
  ],
  btnText: 'I AM INTERESTED',
  heroImageData: {
    alt: 'NasAcademy',
    mobileImgData: {
      webpSrc: `${imagesBaseURL}/webp/bannerMobileV2_360x610.webp`,
      src: `${imagesBaseURL}/png/bannerMobileV2_360x610.png`,
      meta: {
        width: 360,
        height: 610,
      },
    },
    desktopImgData: {
      webpSrc: `${imagesBaseURL}/webp/bannerDesktopV2_705x823.webp`,
      src: `${imagesBaseURL}/png/bannerDesktopV2_705x823.png`,
      meta: {
        width: 705,
        height: 823,
      },
    },
  },
};

export const introBannerStaticPropsV3 = {
  title: [
    { text: 'The Home of Really' },
    { text: ' Good Teachers', isHighlighted: true },
  ],
};

export const coursePickerStaticProps = {
  title: 'COURSE PICKER',
  description: 'Find the best course for you',
  btnText: 'TAKE THE QUIZ',
};

export const trailerVideoProps = {
  srcMap: [
    {
      src:
        'https://d2oi1rqwb0pj00.cloudfront.net/na-website/StoryTellingCourse/video/AOS_2.1_The_Power_of_Words.mp4',
      type: 'video/mp4',
    },
  ],
  controls: true,
  loop: true,
  playsInline: true,
  muted: false,
  checkIsInView: false,
  autoPlay: true,
};

export const referralInfoModalStaticProps = {
  imgSrc: {
    alt: 'Gift Bro',
    mobileImgData: {
      webpSrc: `${imagesBaseURL}/webp/giftBro230x230.webp`,
      src: `${imagesBaseURL}/png/giftBro230x230.png`,
      meta: {
        width: 115,
        height: 115,
      },
    },
    desktopImgData: {
      webpSrc: `${imagesBaseURL}/webp/giftBro506x506.webp`,
      src: `${imagesBaseURL}/png/giftBro506x506.png`,
      meta: {
        width: 253,
        height: 253,
      },
    },
  },
  description:
    'Purchase any Nas Academy course and your discount will be automatically deducted upon checkout.',
  disclaimer: 'Note: Discount does not apply to bundles',
  ctaLabel: 'Continue',
};

// these are specially tailored for home page needs
export const headerMobileOffset = -98;
export const headerDesktopOffset = -125;
